export default __webpack_public_path__ + "static/media/Kelly_Conley_AHV_In_Moms_We_Trust.4ea01e1a.jpg";